import { Checkbox, type CheckboxProps } from "@jti/core-components/components/Checkbox";

import { ConsentBenefitsList } from "./ConsentBenefitsList";

import styles from "../ConsentBlock.module.scss";

type Props = {
  checkboxLabel: string;
  shortHtml: string;
  longHtml?: string;
  showMoreBenefitsButtonLabel?: string;
  showLessBenefitsButtonLabel?: string;
  onCheckedChange: CheckboxProps["onCheckedChange"];
  checked: boolean;
  errorText?: string;
  isError?: boolean;
};

export const ConsentMandatoryCheckbox = ({
  checkboxLabel,
  shortHtml,
  longHtml,
  showMoreBenefitsButtonLabel,
  showLessBenefitsButtonLabel,
  onCheckedChange,
  checked,
  errorText,
  isError,
}: Props) => (
  <fieldset name="consent-checkbox-group" role="group">
    <div className={styles.radioGroupGrid}>
      <Checkbox
        checked={checked}
        label={checkboxLabel}
        onCheckedChange={onCheckedChange}
        errorMessage={errorText}
        status={isError ? "error" : "default"}
      />
      <ConsentBenefitsList
        shortHtml={shortHtml}
        longHtml={longHtml}
        showMoreBenefitsButtonLabel={showMoreBenefitsButtonLabel}
        showLessBenefitsButtonLabel={showLessBenefitsButtonLabel}
      />
    </div>
  </fieldset>
);
